import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconExclamationCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconExclamationCircle"><Circle cx="12" cy="12" r="9.5" stroke="currentColor"/><Path d="M12 6V14" stroke="currentColor"/><Circle cx="12.0002" cy="16.8" r="0.8" fill="currentColor"/></CentralIconBase>;
});

export default IconExclamationCircle;
